"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCognitoRetry = exports.clearDeviceKeys = void 0;
const constants_1 = require("./constants");
const clearDeviceKeys = () => {
    const keys = Object.keys(localStorage);
    const deviceKeys = keys.filter((key) => constants_1.COGNITO_DEVICE_KEYS.some((pattern) => key.includes(pattern)));
    deviceKeys.forEach((key) => localStorage.removeItem(key));
};
exports.clearDeviceKeys = clearDeviceKeys;
const withCognitoRetry = async (fn) => {
    try {
        return await fn();
    }
    catch (error) {
        if (error?.toString().includes(constants_1.DEVICE_NOT_EXIST_ERROR)) {
            (0, exports.clearDeviceKeys)();
            return await fn();
        }
        throw error;
    }
};
exports.withCognitoRetry = withCognitoRetry;
